




import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserStatus } from '@/lib/interfaces/UserStatus.enum'
import { IDriver } from '@/graphql/queries/interfaces/Drivers.interface'
import { cloudFunction } from '@/lib/parse-service'
import query from '@/graphql/queries/DriverStatus.gql'

//@ts-ignore
const timers = []

@Component
export default class DriverStatus extends Vue {

  @Prop({ required: true })
  driver!: IDriver
  
  async mounted() {
    if(this.driver.status === UserStatus.BlockedInProgress) {
      this.refreshInProgressStatus()
    }
  }

  clearTimers()  {
    //@ts-ignore
    timers.forEach(e => window.clearInterval(e))
  }

  async destroyed() {
    this.clearTimers()
  }

  @Watch("driver.status")
  //@ts-ignore
  onStatusChanged(val: UserStatus, _) {
    if(val === UserStatus.BlockedInProgress) {
      this.refreshInProgressStatus()
    } else {
      this.clearTimers()
    }
  }

  async refreshInProgressStatus() {
    timers.push(window.setInterval(() => {
      this.updateStatus()
    }, 250))
  }

  get title() {
    if(this.driver.status == UserStatus.InviteSend) {
      return this.$t("driver.table.text1")
    }
  }

  async updateStatus() {
    const { data } = await this.$apollo.query({
      query,
      fetchPolicy: 'no-cache',
      variables: {
        id: this.driver.id
      }
    })
    this.driver = { 
      ...this.driver, 
      status: data.user.status,
    }
  }

  get status() {
    if (!this.driver) return "no status"
    switch (this.driver.status) {
      case UserStatus.Active:
      case UserStatus.Inactive: // Deprecated
        return this.$t('driver.table.body.status.active')
      case UserStatus.InviteSend:
        return this.$t('driver.table.body.status.sentInvitation')
      case UserStatus.Blocked:
        return this.$t('driver.table.body.status.blocked')
      case UserStatus.BlockedInProgress:
        return this.$t('driver.table.body.status.blockedInProgress')
      default:
        return "no status"
    }
  }

  get isDisabled() {
    return ![
      UserStatus.Active,
      UserStatus.Inactive,
      UserStatus.Blocked,
      // @ts-ignore
    ].includes(this.driver.status)
  }

  async changeStatus() {
    const setActiveStatusTo = this.driver.status === UserStatus.Blocked
    try {
      await cloudFunction('updateDriverStatus', {
        driverId: this.driver.id,
        setActiveStatusTo,
      })
      this.driver = { 
        ...this.driver, 
        status: setActiveStatusTo ? UserStatus.Active : UserStatus.BlockedInProgress 
      }
      this.$toast.open({ type: 'success', message: `${this.$t('toast.success.generic')}` })
    } catch (err) {
      this.$toast.open({ type: 'error', message: `${this.$t('toast.Something went wrong')}` })
    }
  }
}
